import React from "react";
import UserContext from "../../context/UserContext";
import settings from "../../config/settings";
import { asyncStorageGetData } from "../utils/ControllerUtils";
import routesmap from "../../root/data/routesmap";

class BaseController extends React.Component {
  static contextType = UserContext;

  state = {
    columns: null,
    isMobile: false,
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize = () => {
    if (window.innerWidth <= settings.mobileSize && !this.state.isMobile) {
      this.setState({ isMobile: true });
    } else if (window.innerWidth > settings.mobileSize && this.state.isMobile) {
      this.setState({ isMobile: false });
    }

    if (this.handleExtraResize) {
      this.handleExtraResize(window.innerHeight, window.innerWidth);
    }
  };

  handleDefaultColumnsFetch = async (location, defaultValue) => {
    let columns = await asyncStorageGetData(location);
    columns = JSON.parse(columns);

    if (columns === null) {
      columns = defaultValue;
    }

    this.setState({ columns: columns });
  };

  handlePermissionCheck = (
    type = settings.permissionTypeView,
    path = this.props.route?.name,
  ) => {
    return true;
    // first, will fetch the route map object
    const route = routesmap?.find((each) => each.path == path);

    // second, will check if user has permisson to that module
    if (route) {
      const permissions = this.context.user?.permissions?.filter((each) =>
        each.permission_name?.startsWith(
          `${route?.module}.${route?.action}.${type}`,
        ),
      );

      return permissions?.length > 0;
    }

    return false;
  };
}

export default BaseController;
